import { useTranslation } from 'react-i18next';

import * as S from './style';

interface FieldProps {
	title: string;
	children: React.ReactNode;
}

const FieldTextarea = ({ title, children }: FieldProps) => {
	const { t } = useTranslation();

	return (
		<S.Container>
			<S.Label>{t(title)}</S.Label>
			{children}
		</S.Container>
	);
};
export default FieldTextarea;
